  function sendATC(variant_id, qty, priceCents, product_id){
    if (!window.TriplePixel) return;

    // Only fire when we have a numeric value and product_id
    const value = Number.isFinite(priceCents) ? (priceCents * qty) / 100 : undefined;
    if (!product_id || !Number.isFinite(value)) return;

    // Deduplicate by variant_id|qty for a short window
    const key = variant_id + '|' + qty;
    const now = Date.now();
    window.__tw_atc_once = window.__tw_atc_once || Object.create(null);
    if (window.__tw_atc_once[key] && (now - window.__tw_atc_once[key]) < 3000) return;
    window.__tw_atc_once[key] = now;

    window.TriplePixel('custom', 'addToCart', {
      value: value,
      currency: CURRENCY,
      product_id: String(product_id),
      variant_id: String(variant_id),
      quantity: qty
    });
    // console.log('TW ATC SENT', {variant_id, qty, value, product_id});
  }

  (function () {
  // ---- config / utils ------------------------------------------------------
  const CURRENCY =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) ||
    'USD';

  async function fetchCart(){
    const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error('cart.js fetch failed');
    return r.json();
  }

  function isCheckoutURL(u){
    try {
      const url = typeof u === 'string' ? new URL(u, location.origin) : u;
      const p = url.pathname || '';
      return p === '/checkout' || p.startsWith('/checkouts');
    } catch(e){ return false; }
  }

  // ---- sender with hard dedupe --------------------------------------------
  // Dedupes by cart token (preferred) or by a short time window as fallback.
  async function sendInitiateCheckoutOnce(reason){
    if (!window.TriplePixel) return;
    try {
      const cart = await fetchCart();

      // Strong dedupe by cart token
      const token = cart && cart.token ? String(cart.token) : null;
      const now = Date.now();
      window.__tw_ic_seen = window.__tw_ic_seen || Object.create(null);

      if (token) {
        if (window.__tw_ic_seen[token]) return;
        window.__tw_ic_seen[token] = now;
      } else {
        // Fallback time-window dedupe when token missing
        if (window.__tw_ic_last && (now - window.__tw_ic_last) < 4000) return;
        window.__tw_ic_last = now;
      }

      // Build a primitive-only payload
      const value = (typeof cart.total_price === 'number') ? cart.total_price / 100 : undefined;
      const itemCount = Array.isArray(cart.items) ? cart.items.reduce((s, it) => s + (Number(it.quantity)||0), 0) : undefined;

      // Only send if we have a numeric value (prevents validation errors)
      if (typeof value !== 'number' || !Number.isFinite(value)) return;

      const payload = {
        value: value,                 // order subtotal in store currency
        currency: CURRENCY,           // e.g. "USD"
        item_count: itemCount ?? undefined,
        cart_token: token ?? undefined,
        trigger: reason               // "click", "submit", "url"
      };
      // prune undefined keys (TriplePixel only accepts primitives, not undefined)
      Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k]);

      window.TriplePixel('custom', 'initiateCheckout', payload);
      console.log('TW initiateCheckout SENT', payload);
    } catch(e){
      // swallow
    }
  }

  // ---- trigger: clicks that lead to checkout -------------------------------
  function nearest(el, selector){
    for (let n = el; n && n !== document; n = n.parentNode) {
      if (n.matches && n.matches(selector)) return n;
    }
    return null;
  }

  // Common selectors: cart page button, cart drawer buttons, links to /checkout
  const CLICK_SELECTORS = [
    'button[name="checkout"]',
    '[formaction*="/checkout"]',
    'a[href*="/checkout"]',
    '[data-testid*="checkout"]',
    '[data-test*="checkout"]',
    '[data-action*="checkout"]'
  ].join(',');

  document.addEventListener('click', function(e){
    const t = e.target;
    if (!t) return;
    if (nearest(t, CLICK_SELECTORS)) {
      // schedule (don’t block UI)
      setTimeout(() => sendInitiateCheckoutOnce('click'), 0);
    }
  }, true);

  // ---- trigger: cart forms that submit to checkout -------------------------
  document.addEventListener('submit', function(e){
    const form = e.target;
    if (!form) return;
    // Classic cart form often posts to /cart with an input name="checkout"
    const hasCheckoutInput = form.querySelector('button[name="checkout"], input[name="checkout"]');
    const goesToCheckout   = (form.getAttribute('action') || '').includes('/cart');
    if (hasCheckoutInput && goesToCheckout) {
      setTimeout(() => sendInitiateCheckoutOnce('submit'), 0);
    }
  }, true);

  // ---- trigger: URL transitions into checkout (covers some accelerators) ---
  // Fire when we land on /checkout or /checkouts/... due to SPA nav or redirects
  function checkURL(){
    if (isCheckoutURL(location)) {
      // small delay so cart totals reflect any last-second changes
      setTimeout(() => sendInitiateCheckoutOnce('url'), 150);
    }
  }
  // Initial check (in case the snippet loads on checkout)
  checkURL();
  // History changes (for themes using pushState)
  ['pushState','replaceState'].forEach(fn => {
    const orig = history[fn];
    history[fn] = function(){ const r = orig.apply(this, arguments); try { checkURL(); } catch(e){} return r; };
  });
  window.addEventListener('popstate', checkURL);
  window.addEventListener('hashchange', checkURL);
})();